import VueRouter from "vue-router";
import Vue from "vue";
import Auth from "@/plugins/auth";
import Consts from "@/consts";

import LoginIndex from "@/components/login/Login.vue";
import SharedTopBar from "@/components/shared/TopBar.vue";
import SessionsIndex from "@/components/sessions/Index.vue";
import AdminIndex from "@/components/admin/Index.vue";

import AdminSessionsCentersIndex from "@/components/admin/sessions/centers/Index.vue";
import AdminSessionsCentersEdit from "@/components/admin/sessions/centers/Edit.vue";

import AdminSessionsTopicsIndex from "@/components/admin/sessions/topics/Index.vue";
import AdminSessionsTopicsEdit from "@/components/admin/sessions/topics/Edit.vue";
import AdminSessionsTopicsShow from "@/components/admin/sessions/topics/Show.vue";
import AdminSessionsTopicsShowInfo from "@/components/admin/sessions/topics/show/Info.vue";
import AdminSessionsTopicsShowTimeslots from "@/components/admin/sessions/topics/show/Timeslots.vue";
import AdminSessionsTopicsShowIncompatibilities from "@/components/admin/sessions/topics/show/Incompatibilities.vue";
import AdminSessionsTopicsShowAvailabilities from "@/components/admin/sessions/topics/show/Availabilities.vue";

import AdminSessionsTargetsIndex from "@/components/admin/sessions/targets/Index.vue";
import AdminSessionsTargetsEdit from "@/components/admin/sessions/targets/Edit.vue";

import AdminSessionsGroupsTypesIndex from "@/components/admin/sessions/groupstypes/Index.vue";
import AdminSessionsGroupsTypesEdit from "@/components/admin/sessions/groupstypes/Edit.vue";

import AdminSessionsSeasonsIndex from "@/components/admin/sessions/seasons/Index.vue";
import AdminSessionsSeasonsEdit from "@/components/admin/sessions/seasons/Edit.vue";

import AdminSessionsSettingsIndex from "@/components/admin/sessions/settings/Index.vue";
import AdminSessionsSettingsEdit from "@/components/admin/sessions/settings/Edit.vue";
import AdminSessionsActivitiesIndex from "@/components/admin/sessions/activities/Index.vue";
import AdminSessionsActivitiesEdit from "@/components/admin/sessions/activities/Edit.vue";
import AdminSessionsPackagesIndex from "@/components/admin/sessions/packages/Index.vue";
import AdminSessionsPackagesEdit from "@/components/admin/sessions/packages/Edit.vue";
import AdminAddressbookSchooltypesIndex from "@/components/admin/addressbook/schooltypes/Index.vue";
import AdminAddressbookSchooltypesEdit from "@/components/admin/addressbook/schooltypes/Edit.vue";
import AdminAddressbookFunctionsIndex from "@/components/admin/addressbook/functions/Index.vue";
import AdminAddressbookFunctionsEdit from "@/components/admin/addressbook/functions/Edit.vue";
import AdminPlanningPeriodtypesIndex from "@/components/admin/planning/periodtypes/Index.vue";
import AdminPlanningPeriodtypesEdit from "@/components/admin/planning/periodtypes/Edit.vue";
import AdminPlanningPeriodsIndex from "@/components/admin/planning/periods/Index.vue";
import AdminPlanningPeriodsEdit from "@/components/admin/planning/periods/Edit.vue";
import AdminSettingsGroupsIndex from "@/components/admin/settings/groups/Index.vue";
import AdminSettingsGroupsEdit from "@/components/admin/settings/groups/Edit.vue";

import AdminSettingsUsersIndex from "@/components/admin/settings/users/Index.vue";
import AdminSettingsUsersList from "@/components/admin/settings/users/index/List.vue";
import AdminSettingsUsersContracts from "@/components/admin/settings/users/index/Contracts.vue";
import AdminSettingsUsersProfilesMatrix from "@/components/admin/settings/users/index/ProfilesMatrix.vue";
import AdminSettingsUsersEdit from "@/components/admin/settings/users/Edit.vue";
import AdminSettingsUsersShow from "@/components/admin/settings/users/Show.vue";
import AdminSettingsUsersShowInfo from "@/components/admin/settings/users/show/Info.vue";
import AdminSettingsUsersShowContracts from "@/components/admin/settings/users/show/Contracts.vue";

import AdminSessionsTeamsIndex from "@/components/admin/sessions/teams/Index.vue";
import AdminSessionsTeamsEdit from "@/components/admin/sessions/teams/Edit.vue";
import AdminSessionsTeamsShow from "@/components/admin/sessions/teams/Show.vue";
import AdminSessionsTeamsShowInfo from "@/components/admin/sessions/teams/show/Info.vue";
import AdminSessionsTeamsShowExceptions from "@/components/admin/sessions/teams/show/Exceptions.vue";
import AdminSessionsTeamsShowExceptionsEdit from "@/components/admin/sessions/teams/show/exceptions/Edit.vue";

import AdminSettingsUsersShowSkills from "@/components/admin/settings/users/show/Skills.vue";
import AdminSettingsUsersShowSkillsEdit from "@/components/admin/settings/users/show/skills/Edit.vue";
import AdminSettingsUsersShowSkillsSeasons from "@/components/admin/settings/users/show/skills/Seasons.vue";

import AdminSettingsUsersShowHistoric from "@/components/admin/settings/users/show/Historic.vue";

import AdminSettingsValuesIndex from "@/components/admin/settings/values/Index.vue";

//Forms
import AdminFormsIndex from "@/components/admin/forms/forms/Index.vue";
import AdminFormsEdit from "@/components/admin/forms/forms/Edit.vue";
import AdminFormShow from "@/components/admin/forms/forms/Show.vue";
import AdminFormBstypesIndex from "@/components/admin/forms/bstypes/Index.vue";
import AdminFormBstypesEdit from "@/components/admin/forms/bstypes/Edit.vue";

//Fees
import AdminFeesMilageIndex from "@/components/admin/fees/mileages/Index.vue";
import AdminFeesMilageEdit from "@/components/admin/fees/mileages/Edit.vue";
import AdminFeesFreelancesPricesListsIndex from "@/components/admin/fees/freelances-priceslists/Index.vue";
import AdminFeesFreelancesPricesListsEdit from "@/components/admin/fees/freelances-priceslists/Edit.vue";
import AdminFeesBsPricesListsIndex from "@/components/admin/fees/bs-priceslists/Index.vue";
import AdminFeesBsPricesListsEdit from "@/components/admin/fees/bs-priceslists/Edit.vue";

import SessionsEditIndex from "@/components/sessions/edit/Index.vue";
import SessionsEvalsIndex from "@/components/sessions/evals/Index.vue";

import ResetPasswordIndex from "@/components/reset-password/index.vue";
import ResetPasswordVerifyCode from "@/components/reset-password/verify-code.vue";
import ResetPasswordReset from "@/components/reset-password/reset-password.vue";
import CreateAccountIndex from "@/components/create-account/index.vue";
import ConfirmAccountIndex from "@/components/create-account/confirm.vue";
import AddressIndex from "@/components/address-book/Index.vue";
import AddressShow from "@/components/address-book/show.vue";
import AddressShowInfo from "@/components/address-book/show/index.vue";
import AddressShowContacts from "@/components/address-book/show/contacts.vue";
import AddressShowEvals from "@/components/address-book/show/evaluations.vue";
import AddressShowSessions from "@/components/address-book/show/sessions.vue";
import SessionsShowHistoric from "@/components/sessions/show/Historic.vue";
import SessionsShowMaps from "@/components/sessions/show/Maps.vue";
import SessionsShowDaggesrapportEvals from "@/components/sessions/evals/DaggesrapportEvals.vue";
import SessionsShowTrainerEvals from "@/components/sessions/evals/TrainerEvals.vue";
import SessionsEvalReview from "@/components/sessions/evals/Review.vue";
import SessionsShowTeacherEvals from "@/components/sessions/evals/TeacherEvals.vue";
import SessionsShowInternsEvals from "@/components/sessions/evals/InternsEvals.vue";
import SessionsShowInfo from "@/components/sessions/show/Index.vue";
import SessionsShowSettings from "@/components/sessions/show/Settings.vue";
import SessionsShowPackage from "@/components/sessions/show/Package.vue";
import SessionsShowReview from "@/components/sessions/show/Review.vue";
import SessionsShowIndex from "@/components/sessions/show.vue";
import StatisticsIndex from "@/components/statistics/Index.vue";
import StatisticsEntities from "@/components/statistics/Entities.vue";
import StatisticsTypesTopics from "@/components/statistics/TypesTopics.vue";
import StatisticsTrainers from "@/components/statistics/Trainers.vue";
import StatisticsEvals from "@/components/statistics/Evals.vue";
import StatisticsEvalsExport from "@/components/statistics/EvalsExport.vue";
import StatisticsTarget from "@/components/statistics/TargetGroups.vue";
import StatisticsUniv from "@/components/statistics/Univ.vue";
import StatisticsEvents from "@/components/statistics/Events.vue";
import DocumentsIndex from "@/components/documents/Index.vue";
import SessionsMulti from "@/components/sessions/Multi.vue";
import Planning from "@/components/sessions/Planning.vue";
import PlanningMobile from "@/components/sessions/planning/Mobile.vue";
import LogisticsIndex from "@/components/sessions/Logistic.vue";
import GroupsIndex from "@/components/Groups.vue";

//Payments (CT ou ADMIN)
import PaymentsIndex from '@/components/payments/Index.vue'
import PaymentsControlsIndex from '@/components/payments/controls/Index.vue'
import PaymentsPaymentsIndex from '@/components/payments/payments/Index.vue'
import PaymentsPaymentsShow from '@/components/payments/payments/Show.vue'
import PaymentsBatchesIndex from '@/components/payments/payments/Batches/Index.vue'
import PaymentsControlsShow from '@/components/payments/controls/Show.vue'

//Payments (Trainers)
import PaymentsTrainersIndex from '@/components/payments/trainers/Index.vue'
import PaymentsTrainersShow from '@/components/payments/trainers/Show.vue'

import SessionsApi from "@/api/sessions";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      name: "sessions-index",
      path: "/sessions",
      components: {
        top: SharedTopBar,
        body: SessionsIndex
      },
      meta: {
        auth: true
      }
    },
    {
      name: "sessions-add-multi",
      path: "/sessions/multi",
      components: {
        top: SharedTopBar,
        body: SessionsMulti
      },
      meta: {
        auth: true,
        ct: true
      }
    },
    {
      name: "sessions-edit",
      path: "/sessions/:id/edit",
      components: {
        top: SharedTopBar,
        body: SessionsEditIndex
      },
      meta: {
        auth: true,
        ct: true
      }
    },
    {
      name: "sessions-evals",
      path: "/sessions/:id/evaluations",
      components: {
        top: SharedTopBar,
        body: SessionsEvalsIndex
      },
      meta: {
        auth: true
      },
      children: [
        {
          name: "sessions-show-daggesrapport-evals",
          path: "daggesrapport",
          component: SessionsShowDaggesrapportEvals
        },
        {
          name: "sessions-show-trainer-evals",
          path: "trainers",
          component: SessionsShowTrainerEvals
        },
        {
          name: "sessions-show-teacher-evals",
          path: "teachers",
          component: SessionsShowTeacherEvals,
          meta: {
            notForTrainer: true
          }
        },
        {
          name: "sessions-show-interns-evals",
          path: "interns",
          component: SessionsShowInternsEvals,
        },
        {
          name: "sessions-edit-review",
          path: "review",
          component: SessionsEvalReview
        }
      ]
    },
    {
      name: "sessions-show",
      path: "/sessions/:id/show",
      components: {
        top: SharedTopBar,
        body: SessionsShowIndex
      },
      meta: {
        auth: true,
        ctrlStatus: true
      },
      children: [
        {
          name: "sessions-show-info",
          path: "info",
          component: SessionsShowInfo
        },
        {
          name: "sessions-show-settings",
          path: "settings",
          component: SessionsShowSettings
        },
        {
          name: "sessions-show-package",
          path: "package",
          component: SessionsShowPackage
        },
        {
          name: "sessions-show-review",
          path: "review",
          component: SessionsShowReview
        },
        {
          name: "sessions-show-historic",
          path: "historic",
          component: SessionsShowHistoric
        },
        {
          name: "sessions-show-maps",
          path: "maps",
          component: SessionsShowMaps
        }
      ]
    },
    {
      name: "planning-index",
      path: "/planning",
      components: {
        top: SharedTopBar,
        body: Planning
      },
      meta: {
        auth: true
      }
    },
    {
      name: "planning-mobile",
      path: "/planning/mobile",
      components: {
        top: SharedTopBar,
        body: PlanningMobile
      },
      meta: {
        auth: true
      }
    },
    {
      name: "address-index",
      path: "/address",
      components: {
        top: SharedTopBar,
        body: AddressIndex
      },
      meta: {
        auth: true
      }
    },
    {
      name: "address-show",
      path: "/address/:id/show",
      components: {
        top: SharedTopBar,
        body: AddressShow
      },
      meta: {
        auth: true
      },
      children: [
        { name: "address-show-info", path: "info", component: AddressShowInfo },
        {
          name: "address-show-contacts",
          path: "contacts",
          component: AddressShowContacts
        },
        {
          name: "address-show-evals",
          path: "evaluations",
          component: AddressShowEvals
        },
        {
          name: "address-show-sessions",
          path: "sessions",
          component: AddressShowSessions
        }
      ]
    },
    {
      name: "logistics-index",
      path: "/logistics",
      components: {
        top: SharedTopBar,
        body: LogisticsIndex
      },
      meta: {
        auth: true,
        acl: () => Auth.user.is_admin && (Auth.user.application == Consts.APPLICATION.ALL || Auth.user.application == Consts.APPLICATION.BEESECURE)
      }
    },
    {
      name: "groups-index",
      path: "/groups",
      components: {
        top: SharedTopBar,
        body: GroupsIndex
      },
      meta: {
        auth: true
      }
    },
    {
      name: "topten-index",
      path: "/topten",
      components: {
        top: SharedTopBar
        // body: SessionsIndex
      },
      meta: {
        auth: true
      }
    },
    {
      name: "documents-index",
      path: "/documents",
      components: {
        top: SharedTopBar,
        body: DocumentsIndex
      },
      meta: {
        auth: true
      }
    },
    {
      name: "admin-index",
      path: "/admin",
      components: {
        top: SharedTopBar,
        body: AdminIndex
      },
      meta: {
        auth: true,
        admin: true
      },
      redirect: { name: "admin-sessions-topics-index" },
      children: [
        {
          name: "admin-sessions-centers-index",
          path: "sessions/centers",
          components: {
            adminbody: AdminSessionsCentersIndex
          }
        },
        {
          name: "admin-sessions-centers-edit",
          path: "sessions/centers/:id",
          components: {
            adminbody: AdminSessionsCentersEdit
          }
        },
        {
          name: "admin-sessions-topics-index",
          path: "sessions/topics",
          components: {
            adminbody: AdminSessionsTopicsIndex
          }
        },
        {
          name: "admin-sessions-topics-edit",
          path: "sessions/topics/:id",
          components: {
            adminbody: AdminSessionsTopicsEdit
          }
        },
        {
          name: "admin-sessions-topics-show",
          path: "sessions/topics/:id/show",
          components: {
            adminbody: AdminSessionsTopicsShow
          },
          meta: {
            auth: true
          },
          redirect: { name: "admin-sessions-topics-show-info" },
          children: [
            {
              name: "admin-sessions-topics-show-info",
              path: "info",
              component: AdminSessionsTopicsShowInfo
            },
            {
              name: "admin-sessions-topics-show-timeslots",
              path: "timeslots",
              component: AdminSessionsTopicsShowTimeslots
            },
            {
              name: "admin-sessions-topics-show-incompatibilities",
              path: "incompatibilities",
              component: AdminSessionsTopicsShowIncompatibilities
            },
            {
              name: "admin-sessions-topics-show-availabilities",
              path: "availabilities",
              component: AdminSessionsTopicsShowAvailabilities
            }
          ]
        },
        {
          name: "admin-sessions-targets-index",
          path: "sessions/targets",
          components: {
            adminbody: AdminSessionsTargetsIndex
          }
        },
        {
          name: "admin-sessions-targets-edit",
          path: "sessions/targets/:id",
          components: {
            adminbody: AdminSessionsTargetsEdit
          }
        },
        {
          name: "admin-sessions-groupstypes-index",
          path: "sessions/groupstypes",
          components: {
            adminbody: AdminSessionsGroupsTypesIndex
          }
        },
        {
          name: "admin-sessions-groupstypes-edit",
          path: "sessions/groupstypes/:id",
          components: {
            adminbody: AdminSessionsGroupsTypesEdit
          }
        },
        {
          name: "admin-sessions-teams-index",
          path: "sessions/teams",
          components: {
            adminbody: AdminSessionsTeamsIndex
          }
        },
        {
          name: "admin-sessions-teams-edit",
          path: "sessions/teams/:id",
          components: {
            adminbody: AdminSessionsTeamsEdit
          }
        },
        {
          name: "admin-sessions-teams-show",
          path: "sessions/teams/:id/show",
          components: {
            adminbody: AdminSessionsTeamsShow
          },
          meta: {
            auth: true
          },
          redirect: { name: "admin-sessions-teams-show-info" },
          children: [
            {
              name: "admin-sessions-teams-show-info",
              path: "info",
              component: AdminSessionsTeamsShowInfo
            },
            {
              name: "admin-sessions-teams-show-exceptions",
              path: "exceptions",
              component: AdminSessionsTeamsShowExceptions
            },
            {
              name: "admin-sessions-teams-show-exceptions-edit",
              path: "exceptions/:exception_id",
              component: AdminSessionsTeamsShowExceptionsEdit
            },
          ]
        },
        {
          name: "admin-sessions-seasons-index",
          path: "sessions/seasons",
          components: {
            adminbody: AdminSessionsSeasonsIndex
          }
        },
        {
          name: "admin-sessions-seasons-edit",
          path: "sessions/seasons/:id",
          components: {
            adminbody: AdminSessionsSeasonsEdit
          }
        },
        {
          name: "admin-sessions-settings-index",
          path: "sessions/settings",
          components: {
            adminbody: AdminSessionsSettingsIndex
          }
        },
        {
          name: "admin-sessions-settings-edit",
          path: "sessions/settings/:id",
          components: {
            adminbody: AdminSessionsSettingsEdit
          }
        },
        {
          name: "admin-sessions-activities-index",
          path: "sessions/activities",
          components: {
            adminbody: AdminSessionsActivitiesIndex
          }
        },
        {
          name: "admin-sessions-activities-edit",
          path: "sessions/activities/:id",
          components: {
            adminbody: AdminSessionsActivitiesEdit
          }
        },
        {
          name: "admin-sessions-packages-edit",
          path: "sessions/packages/:id",
          components: {
            adminbody: AdminSessionsPackagesEdit
          }
        },
        {
          name: "admin-sessions-packages-index",
          path: "sessions/packages",
          components: {
            adminbody: AdminSessionsPackagesIndex
          }
        },
        {
          name: "admin-addressbook-schooltypes-index",
          path: "addressbook/schooltypes",
          components: {
            adminbody: AdminAddressbookSchooltypesIndex
          }
        },
        {
          name: "admin-addressbook-schooltypes-edit",
          path: "addressbook/schooltypes/:id",
          components: {
            adminbody: AdminAddressbookSchooltypesEdit
          }
        },
        {
          name: "admin-addressbook-functions-index",
          path: "addressbook/functions",
          components: {
            adminbody: AdminAddressbookFunctionsIndex
          }
        },
        {
          name: "admin-addressbook-functions-edit",
          path: "addressbook/functions/:id",
          components: {
            adminbody: AdminAddressbookFunctionsEdit
          }
        },
        {
          name: "admin-planning-periodtypes-index",
          path: "planning/periodtypes",
          components: {
            adminbody: AdminPlanningPeriodtypesIndex
          }
        },
        {
          name: "admin-planning-periodtypes-edit",
          path: "planning/periodtypes/:id",
          components: {
            adminbody: AdminPlanningPeriodtypesEdit
          }
        },
        {
          name: "admin-planning-periods-index",
          path: "planning/periods",
          components: {
            adminbody: AdminPlanningPeriodsIndex
          }
        },
        {
          name: "admin-planning-periods-edit",
          path: "planning/periods/:id",
          components: {
            adminbody: AdminPlanningPeriodsEdit
          }
        },
        {
          name: "admin-settings-groups-index",
          path: "settings/groups",
          components: {
            adminbody: AdminSettingsGroupsIndex
          }
        },
        {
          name: "admin-settings-groups-edit",
          path: "settings/groups/:id",
          components: {
            adminbody: AdminSettingsGroupsEdit
          }
        },
        {
          name: "admin-settings-users-index",
          path: "settings/users",
          components: {
            adminbody: AdminSettingsUsersIndex
          },
          meta: {
            auth: true
          },
          redirect: { name: "admin-settings-users-list" },
          children: [
            {
              name: "admin-settings-users-list",
              path: "list",
              component: AdminSettingsUsersList
            },
            {
              name: "admin-settings-users-profiles-matrix",
              path: "profiles-matrix",
              component: AdminSettingsUsersProfilesMatrix
            },
            {
              name: "admin-settings-users-contracts",
              path: "contracts",
              component: AdminSettingsUsersContracts
            }
          ]
        },
        {
          name: "admin-settings-users-edit",
          path: "settings/users/:id",
          components: {
            adminbody: AdminSettingsUsersEdit
          }
        },
        {
          name: "admin-forms-index",
          path: "forms",
          components: {
            adminbody: AdminFormsIndex
          }
        },
        {
          name: "admin-forms-edit",
          path: "forms/:id/edit",
          components: {
            adminbody: AdminFormsEdit
          }
        },
        {
          name: "admin-forms-fields-index",
          path: "forms/:id/show",
          components: {
            adminbody: AdminFormShow
          }
        },
        {
          name: "admin-forms-bstypes-index",
          path: "bstypes",
          components: {
            adminbody: AdminFormBstypesIndex
          }
        },
        {
          name: "admin-forms-bstypes-edit",
          path: "bstypes/:id/edit",
          components: {
            adminbody: AdminFormBstypesEdit
          }
        },
        {
          name: "admin-fees-mileage-index",
          path: "mileages-fees",
          components: {
            adminbody: AdminFeesMilageIndex
          }
        },
        {
          name: "admin-fees-mileage-edit",
          path: "mileages-fees/:id/edit",
          components: {
            adminbody: AdminFeesMilageEdit
          }
        },
        {
          name: "admin-fees-freelances-priceslists-index",
          path: "freelances-priceslists",
          components: {
            adminbody: AdminFeesFreelancesPricesListsIndex
          }
        },
        {
          name: "admin-fees-freelances-priceslists-edit",
          path: "freelances-priceslists/:id/edit",
          components: {
            adminbody: AdminFeesFreelancesPricesListsEdit
          }
        },
        {
          name: "admin-fees-bs-priceslists-index",
          path: "bs-priceslists",
          components: {
            adminbody: AdminFeesBsPricesListsIndex
          }
        },
        {
          name: "admin-fees-bs-priceslists-edit",
          path: "bs-priceslists/:id/edit",
          components: {
            adminbody: AdminFeesBsPricesListsEdit
          }
        },
        {
          name: "admin-settings-users-show",
          path: "settings/users/:id/show",
          components: {
            adminbody: AdminSettingsUsersShow
          },
          meta: {
            auth: true
          },
          redirect: { name: "admin-settings-users-show-info" },
          children: [
            {
              name: "admin-settings-users-show-info",
              path: "info",
              component: AdminSettingsUsersShowInfo
            },
            {
              name: "admin-settings-users-show-contracts",
              path: "contracts",
              component: AdminSettingsUsersShowContracts
            },
            {
              name: "admin-settings-users-show-skills",
              path: "skills",
              component: AdminSettingsUsersShowSkills
            },
            {
              name: "admin-settings-users-show-skills-edit",
              path: "skills/:skill_id",
              component: AdminSettingsUsersShowSkillsEdit
            },
            {
              name: "admin-settings-users-show-skills-seasons",
              path: "skills/:skill_id/seasons",
              component: AdminSettingsUsersShowSkillsSeasons
            },
            {
              name: "admin-settings-users-show-historic",
              path: "historic",
              component: AdminSettingsUsersShowHistoric
            }
          ]
        },
        {
          name: "admin-settings-values-index",
          path: "settings/values",
          components: {
            adminbody: AdminSettingsValuesIndex
          }
        }
      ]
    },
    {
      name: "login",
      path: "/login",
      components: {
        body: LoginIndex
      },
      meta: {
        auth: false
      }
    },
    {
      name: "reset-password-index",
      path: "/reset-password",
      components: {
        body: ResetPasswordIndex
      },
      meta: {
        auth: false
      }
    },
    {
      name: "reset-password-verify-code",
      path: "/reset-password/:id/verify-code",
      components: {
        body: ResetPasswordVerifyCode
      },
      meta: {
        auth: false
      }
    },
    {
      name: "reset-password-reset",
      path: "/reset-password/:id/reset",
      components: {
        body: ResetPasswordReset
      },
      meta: {
        auth: false
      }
    },
    {
      name: "create-account-index",
      path: "/create-account",
      components: {
        body: CreateAccountIndex
      },
      meta: {
        auth: false
      }
    },
    {
      name: "confirm-account-index",
      path: "/confirm-account/:token",
      components: {
        body: ConfirmAccountIndex
      },
      meta: {
        auth: false
      }
    },
    {
      name: "stats-index",
      path: "/statistics",
      components: {
        top: SharedTopBar,
        body: StatisticsIndex
      },
      meta: {
        auth: true
      },
      redirect: { name: "statistics-entities" },
      children: [
        {
          name: "statistics-entities",
          path: "entities",
          component: StatisticsEntities
        },
        {
          name: "statistics-types-topics",
          path: "types-topics",
          component: StatisticsTypesTopics
        },
        {
          name: "statistics-trainers",
          path: "trainers",
          component: StatisticsTrainers
        },
        {
          name: "statistics-evals",
          path: "evaluations/:sessionType",
          component: StatisticsEvals
        },
        {
          name: "statistics-evals-export",
          path: "evaluations-export",
          component: StatisticsEvalsExport
        },
        {
          name: "statistics-target",
          path: "target-groups/:sessionType",
          component: StatisticsTarget
        },
        {
          name: "statistics-univ",
          path: "university",
          component: StatisticsUniv
        },
        {
          name: "statistics-events",
          path: "events",
          component: StatisticsEvents
        }
      ]
    },
    {
      name: "payments-trainers-index",
      path: "/my-indemnities",
      components: {
        top: SharedTopBar,
        body: PaymentsTrainersIndex
      },
      meta: {
        auth: true,
        notForTrainer: false
      }
    },
    {
      name: "payments-trainers-show",
      path: "/my-indemnities/:id",
      components: {
        top: SharedTopBar,
        body: PaymentsTrainersShow
      },
      meta: {
        auth: true,
        notForTrainer: false
      }
    },
    {
      name: "payments-index",
      path: "/payments",
      components: {
        top: SharedTopBar,
        body: PaymentsIndex
      },
      meta: {
        auth: true,
        notForTrainer: true
      },
      redirect: {name: "payments-controls-index"},
      children: [
        {
          name: "payments-controls-index",
          path: "/payments/controls",
          component: PaymentsControlsIndex,
          meta: {
            notForTrainer: true
          }
        },
        {
          name: "payments-controls-show",
          path: "/payments/controls/:id",
          component: PaymentsControlsShow,
          meta: {
            notForTrainer: true
          }
        },
        {
          name: "payments-payments-index",
          path: "/payments/payments",
          component: PaymentsPaymentsIndex,
          meta: {
            notForTrainer: true
          }
        },
        {
          name: "payments-payments-batches",
          path: "/payments/payments/batches",
          component: PaymentsBatchesIndex,
          meta: {
            notForTrainer: true
          }
        },
        {
          name: "payments-payments-show",
          path: "/payments/payments/:id",
          component: PaymentsPaymentsShow,
          props: true,
          meta: {
            notForTrainer: true
          }
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    if (to.name) {
      /*Message.error({
                title: 'Erreur de route',
                message: 'Aucune route ne possède le nom "' + to.name + '". Cette page est probablement en chantier.'
            });*/
      return;
    }
  }

  if (to.name && to.matched[0].meta.auth && !Auth.authenticated) {
    // This route requires an authentication, and user isn't
    // authenticated. Redirect him to the login page.
    router.push({ name: "login" });
  } else if (to.name && to.matched[0].meta.ct && !Auth.ct) {
    router.push({ name: "sessions-index" });
  } else if (to.name && to.matched[0].meta.admin && !Auth.user.is_admin) {
    router.push({ name: "sessions-index" });
  } else if (to.name && to.matched[0].meta.acl && !to.matched[0].meta.acl()) {
    router.push({ name: "sessions-index" });
  } else {
    next();
  }

  if(to.name && to.matched[0].meta.ctrlStatus) {
    //on doit vérifier que la session à laquelle on tente d'accéder est accessible par l'utilisateur connecté
    SessionsApi.get(to.params.id).then(data => {
      const isTrainer = Auth.user.role == Consts.TRAINER
      const isCoord = Auth.user.role == Consts.COORDINATION
      const allowedStatusForATrainer = [Consts.RELEASE, Consts.TOVALIDATE, Consts.BLOCKED, Consts.TOEVALUATE, Consts.TOCONTROL]
      if(!isTrainer || isCoord || allowedStatusForATrainer.indexOf(data.data.status) > -1 || (isTrainer && data.data.status == Consts.CLOSED && data.data.trainers.find(t => t.id == Auth.user.id) )) {
        next()
      }
      else {
        router.push({ name: "sessions-index" });
      }
    })
  }
  if(to.name && to.matched[1] && to.matched[1].meta.notForTrainer) {
    if( ! (Auth.user.is_admin || Auth.user.role == Consts.COORDINATION) ) {
      router.push({ name: "sessions-index" });
    }
    else {
      next()
    }
  }
});

export default router;
